import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06e86ee1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "container_star" }
const _hoisted_3 = {
  key: 1,
  class: "container"
}
const _hoisted_4 = { class: "container_star" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "con_grid" }, [
  /*#__PURE__*/_createElementVNode("div", null, "平台"),
  /*#__PURE__*/_createElementVNode("div", null, "推流地址/直播码")
], -1))
const _hoisted_6 = { class: "list" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = { class: "mar_left" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "footer" }
const _hoisted_14 = { style: {"width":"80%"} }
const _hoisted_15 = { class: "number" }
const _hoisted_16 = { class: "modal" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "平台名称：", -1))
const _hoisted_18 = { class: "modal" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "推流地址：", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 提示：如您的“推流地址”和“推流码”是拆开的格式，请在“推流地址”后补充“/”，然后把推流码添加在“/”后即可，注意前后不能留有空格。 ", -1))

import { QuestionCircleFilled } from '@ant-design/icons-vue';
import { message, Tooltip, Modal } from 'ant-design-vue';
import { onMounted, onUnmounted, reactive, ref } from 'vue';
import { MulPush, DelModal } from './liveMode.js';
import { useDebounce } from '@/hooks/useDebounce';
import { emptyDataSec } from '@/assets';
import CDelModal from '@/components/CDelModal.vue';
import http from '@/api';
import router from '@/router';
import EventBus from '@/components/EventBus';


export default /*#__PURE__*/_defineComponent({
  __name: 'PlatformPushs',
  setup(__props) {

const aTooltip = Tooltip;
const aModal = Modal;
const studioId = router.currentRoute.value.params.studioId;
const dataArr = ref<MulPush[]>([]);
const visible = ref(false);
const duration = ref();
// 获取转推配置
const getDescribeProjects = () => {
  http.liveMode
    .describeProjects({ studio_id: parseInt(studioId as string) })
    .then((res) => {
      res.data.data.out_input.length > 0 ? (dataArr.value = res.data.data.out_input) : (dataArr.value = []);
      pushBtn.value = res.data.data ? res.data.data.switch_status : '';
      res.data.data ? (record.value = true) : (record.value = false);
      duration.value = dataArr.value.forEach((e) => e.duration);
      beginTimer(duration.value, pushBtn.value);
    })
    .catch(() => {
      // message.error(err.data.error);
    });
};
getDescribeProjects();

// 创建，添加转推
const record = ref(false);
const createPush = () => {
  const data = {
    studio_id: parseInt(studioId as string),
    out_input: JSON.stringify(createData),
  };
  if (streamItem.value) {
    updataData();
  } else if (dataArr.value.length === 0 && record.value === false) {
    // 新建
    http.liveMode
      .createStream(data)
      .then((res) => {
        message.success(res.data.message);
        visible.value = false;
        getDescribeProjects();
      })
      .catch((err) => {
        message.error(err.data.error);
      });
  } else {
    // 添加
    http.liveMode
      .addOutput(data)
      .then((res) => {
        message.success(res.data.message);
        visible.value = false;
        getDescribeProjects();
      })
      .catch((err) => {
        message.error(err.data.error);
      });
  }
};

// 添加/修改
const streamItem = ref<any>();
const openAdd = (item?: MulPush) => {
  if (item) {
    // 修改
    streamItem.value = item;
    visible.value = true;
    createData[0].name = item.name;
    createData[0].push_url = item.push_url;
  } else {
    // 新建、添加
    streamItem.value = '';
    visible.value = true;
    createData[0].name = '';
    createData[0].push_url = '';
  }
};
const createData = reactive<MulPush[]>([
  {
    name: '',
    push_url: '',
  },
]);
// 修改
const updataData = () => {
  const data = {
    studio_id: parseInt(studioId as string),
    id: streamItem.value.id,
    name: createData[0].name,
    push_url: createData[0].push_url,
  };
  http.liveMode
    .updataOutput(data)
    .then((res) => {
      message.success(res.data.message);
      visible.value = false;
      getDescribeProjects();
    })
    .catch((err) => {
      message.error(err.data.error);
    });
};

// 开始、结束转推
const pushBtn = ref();
const conductWork = useDebounce(() => {
  const start_stop = pushBtn.value === 1 ? 0 : 1;
  http.liveMode
    .conductWork({ studio_id: parseInt(studioId as string), start_stop: start_stop.toString() })
    .then((res) => {
      // pushBtn.value = start_stop;
      // getDescribeProjects();
    })
    .catch((err) => {
      message.error(err.data.error);
    });
});

// 删除
const delModal = reactive<DelModal>({
  singleDel: false, //单个删除
  wholeDel: false, //一键删除
});
const outputId = ref();
const showDelModal = (key: number, item?: any) => {
  item ? (outputId.value = item.id) : '';
  if (key === 0) delModal.singleDel = !delModal.singleDel; //单个删除
  if (key === 1) delModal.wholeDel = !delModal.wholeDel; // 清空
};
// 删除单项
const deleteOutput = () => {
  http.liveMode
    .delOutput({ studio_id: parseInt(studioId as string), id: outputId.value })
    .then((res) => {
      message.success(res.data.message);
      delModal.singleDel = false;
      getDescribeProjects();
    })
    .catch((err) => {
      message.error(err.data.error);
    });
};
// 一键清空
const delProject = () => {
  http.liveMode
    .delProject({ studio_id: parseInt(studioId as string) })
    .then((res) => {
      message.success(res.data.message);
      delModal.wholeDel = false;
      getDescribeProjects();
      dataArr.value = [];
      record.value = false;
    })
    .catch((err) => {
      message.error(err.data.error);
    });
};

const contentRef = ref();
const showHeight = ref();
onMounted(() => {
  showHeight.value = contentRef.value.clientHeight;
});

const timer = ref(0);
const IntervalKey = ref();
const overtime = ref<any>('00:00:00');

const beginTimer = (duration?: any, status?: any) => {
  function addZero(i: number) {
    return i < 10 ? `0${i}` : i;
  }
  duration ? (timer.value = duration) : '';
  IntervalKey.value = setInterval(() => {
    if (status) {
      timer.value = timer.value + 1;
    }
    const hour = parseInt(((timer.value / (60 * 60)) % 24).toString(), 10);
    const minute = parseInt(((timer.value / 60) % 60).toString(), 10);
    const second = parseInt((timer.value % 60).toString(), 10);
    overtime.value = `${addZero(hour)}:${addZero(minute)}:${addZero(second)}`;
  }, 1000);
};

// const startStop = ref();
const turnPushStatus = (data: any) => {
  pushBtn.value = data.status;
  if (data.status === 1) {
    timer.value = 0;
    overtime.value = '00:00:00';
    beginTimer('', data.status);
  } else {
    clearInterval(IntervalKey.value);
  }
};
EventBus.on('turnPushStatus', turnPushStatus);
onUnmounted(() => {
  EventBus.off('turnPushStatus', turnPushStatus);
});

onUnmounted(() => {
  clearInterval(IntervalKey.value);
});

return (_ctx: any,_cache: any) => {
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "content",
      ref_key: "contentRef",
      ref: contentRef
    }, [
      (dataArr.value.length === 0 && showHeight.value > 225)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_a_empty, {
              class: "null_img",
              image: _unref(emptyDataSec),
              description: "页面暂无数据信息~"
            }, null, 8, ["image"]),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_a_button, {
                type: "primary",
                class: "container_but mar_left",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (openAdd())),
                disabled: dataArr.value.length > 9
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_svg_icon, {
                      "icon-class": "all_add",
                      class: "but_icon"
                    }),
                    _createTextVNode("添加转推")
                  ])
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_a_button, {
                type: "primary",
                class: "container_but mar_left",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (openAdd())),
                disabled: dataArr.value.length > 9
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_svg_icon, {
                      "icon-class": "all_add",
                      class: "but_icon"
                    }),
                    _createTextVNode("添加转推")
                  ])
                ]),
                _: 1
              }, 8, ["disabled"]),
              (pushBtn.value === 0)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    type: "primary",
                    class: "container_but mar_left",
                    onClick: _unref(conductWork)
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_svg_icon, {
                          "icon-class": "all_start",
                          class: "but_icon"
                        }),
                        _createTextVNode("开始转推")
                      ])
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    type: "primary",
                    class: "stop_but mar_left",
                    onClick: _unref(conductWork)
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_svg_icon, {
                          "icon-class": "all_stop",
                          class: "but_icon"
                        }),
                        _createTextVNode("停止转推")
                      ])
                    ]),
                    _: 1
                  }, 8, ["onClick"])),
              _createVNode(_component_a_button, {
                type: "primary",
                class: "container_but mar_left",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (showDelModal(1)))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_svg_icon, {
                      "icon-class": "all_del",
                      class: "but_icon"
                    }),
                    _createTextVNode("一键清除")
                  ])
                ]),
                _: 1
              })
            ]),
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataArr.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "con_grid",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_svg_icon, {
                      "icon-class": "relay_title",
                      class: "mar"
                    }),
                    _createTextVNode(),
                    _createVNode(_component_a_input, {
                      value: item.name,
                      "onUpdate:value": ($event: any) => ((item.name) = $event),
                      class: "write",
                      readonly: ""
                    }, null, 8, ["value", "onUpdate:value"])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_svg_icon, {
                      "icon-class": "relay_push",
                      class: "mar"
                    }),
                    _createTextVNode(),
                    _createVNode(_component_a_input, {
                      value: item.push_url,
                      "onUpdate:value": ($event: any) => ((item.push_url) = $event),
                      class: "write",
                      readonly: ""
                    }, null, 8, ["value", "onUpdate:value"])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(overtime.value), 1),
                    _createElementVNode("div", {
                      class: "btn_bg mar_left",
                      onClick: ($event: any) => (openAdd(item))
                    }, [
                      _createVNode(_component_svg_icon, { "icon-class": "operation" })
                    ], 8, _hoisted_11),
                    _createElementVNode("div", {
                      class: "btn_bg mar_left",
                      onClick: ($event: any) => (showDelModal(0, item))
                    }, [
                      _createVNode(_component_svg_icon, { "icon-class": "chat_empty" })
                    ], 8, _hoisted_12)
                  ])
                ]))
              }), 128))
            ])
          ]))
    ], 512),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("p", _hoisted_14, [
        _createTextVNode(" 计费说明：每发布一路第三方平台的转推直播，按照0.5元/分钟/路收取费用，不足1分钟按1分钟计算，请您注意帐户余额， 单次最长转推时长不超过24小时 (超过后自动终止)。 "),
        _createVNode(_unref(aTooltip), { placement: "right" }, {
          title: _withCtx(() => [
            _createTextVNode("通过多平台转推功能可实现在多个平台的同步直播，无需单独对每个平台设置推流。")
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(QuestionCircleFilled), { class: "icon" })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("p", null, [
        _createTextVNode(" 转推路数限制： "),
        _createElementVNode("span", _hoisted_15, _toDisplayString(dataArr.value.length), 1),
        _createTextVNode(" /10 ")
      ])
    ]),
    _createVNode(_unref(aModal), {
      visible: visible.value,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((visible).value = $event)),
      title: streamItem.value ? '修改转推平台' : '添加转推平台',
      centered: "",
      onOk: createPush
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createTextVNode(),
          _createVNode(_component_a_input, {
            value: createData[0].name,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((createData[0].name) = $event))
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createTextVNode(),
          _createVNode(_component_a_input, {
            value: createData[0].push_url,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((createData[0].push_url) = $event))
          }, null, 8, ["value"])
        ]),
        _hoisted_20
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(CDelModal, {
      visible: delModal.singleDel,
      centered: "",
      close: () => showDelModal(0),
      ok: deleteOutput
    }, null, 8, ["visible", "close"]),
    _createVNode(CDelModal, {
      visible: delModal.wholeDel,
      centered: "",
      close: () => showDelModal(1),
      ok: delProject
    }, {
      title: _withCtx(() => [
        _createTextVNode("此操作将清空全部转推平台数据，是否继续？")
      ]),
      _: 1
    }, 8, ["visible", "close"])
  ], 64))
}
}

})